import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../js/compareTo.mjs';
import {
  numberToLong2pakxeg38estk as numberToLong,
  dividelr0uqtdj497z as divide,
  multiply2k9eolhnz1bjv as multiply,
} from '../js/internal/longAsBigInt/longAsBigInt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  DurationUnit_NANOSECONDS_instance = new (DurationUnit())('NANOSECONDS', 0, 1.0);
  DurationUnit_MICROSECONDS_instance = new (DurationUnit())('MICROSECONDS', 1, 1000.0);
  DurationUnit_MILLISECONDS_instance = new (DurationUnit())('MILLISECONDS', 2, 1000000.0);
  DurationUnit_SECONDS_instance = new (DurationUnit())('SECONDS', 3, 1.0E9);
  DurationUnit_MINUTES_instance = new (DurationUnit())('MINUTES', 4, 6.0E10);
  DurationUnit_HOURS_instance = new (DurationUnit())('HOURS', 5, 3.6E12);
  DurationUnit_DAYS_instance = new (DurationUnit())('DAYS', 6, 8.64E13);
}
var DurationUnit_NANOSECONDS_instance;
var DurationUnit_MICROSECONDS_instance;
var DurationUnit_MILLISECONDS_instance;
var DurationUnit_SECONDS_instance;
var DurationUnit_MINUTES_instance;
var DurationUnit_HOURS_instance;
var DurationUnit_DAYS_instance;
var DurationUnitClass;
function DurationUnit() {
  if (DurationUnitClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, scale) {
        super(name, ordinal);
        this.scale_1 = scale;
      }
    }
    initMetadataForClass($, 'DurationUnit');
    DurationUnitClass = $;
  }
  return DurationUnitClass;
}
function convertDurationUnit(value, sourceUnit, targetUnit) {
  var sourceCompareTarget = compareTo(sourceUnit.scale_1, targetUnit.scale_1);
  return sourceCompareTarget > 0 ? value * (sourceUnit.scale_1 / targetUnit.scale_1) : sourceCompareTarget < 0 ? value / (targetUnit.scale_1 / sourceUnit.scale_1) : value;
}
function convertDurationUnit_0(value, sourceUnit, targetUnit) {
  var sourceCompareTarget = compareTo(sourceUnit.scale_1, targetUnit.scale_1);
  var tmp;
  if (sourceCompareTarget > 0) {
    var scale = numberToLong(sourceUnit.scale_1 / targetUnit.scale_1);
    var result = multiply(value, scale);
    tmp = divide(result, scale) === value ? result : value > 0n ? 9223372036854775807n : -9223372036854775808n;
  } else if (sourceCompareTarget < 0) {
    tmp = divide(value, numberToLong(targetUnit.scale_1 / sourceUnit.scale_1));
  } else {
    tmp = value;
  }
  return tmp;
}
function convertDurationUnitOverflow(value, sourceUnit, targetUnit) {
  var sourceCompareTarget = compareTo(sourceUnit.scale_1, targetUnit.scale_1);
  return sourceCompareTarget > 0 ? multiply(value, numberToLong(sourceUnit.scale_1 / targetUnit.scale_1)) : sourceCompareTarget < 0 ? divide(value, numberToLong(targetUnit.scale_1 / sourceUnit.scale_1)) : value;
}
function DurationUnit_NANOSECONDS_getInstance() {
  static_init();
  return DurationUnit_NANOSECONDS_instance;
}
function DurationUnit_MICROSECONDS_getInstance() {
  static_init();
  return DurationUnit_MICROSECONDS_instance;
}
function DurationUnit_MILLISECONDS_getInstance() {
  static_init();
  return DurationUnit_MILLISECONDS_instance;
}
function DurationUnit_SECONDS_getInstance() {
  static_init();
  return DurationUnit_SECONDS_instance;
}
function DurationUnit_MINUTES_getInstance() {
  static_init();
  return DurationUnit_MINUTES_instance;
}
function DurationUnit_HOURS_getInstance() {
  static_init();
  return DurationUnit_HOURS_instance;
}
function DurationUnit_DAYS_getInstance() {
  static_init();
  return DurationUnit_DAYS_instance;
}
//region block: exports
export {
  DurationUnit_DAYS_getInstance as DurationUnit_DAYS_getInstance3he068lsy3pdd,
  DurationUnit_HOURS_getInstance as DurationUnit_HOURS_getInstance2sdyct9eiytro,
  DurationUnit_MICROSECONDS_getInstance as DurationUnit_MICROSECONDS_getInstance3qb7b7owxf6lo,
  DurationUnit_MILLISECONDS_getInstance as DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm,
  DurationUnit_MINUTES_getInstance as DurationUnit_MINUTES_getInstance33ilufdckt9os,
  DurationUnit_NANOSECONDS_getInstance as DurationUnit_NANOSECONDS_getInstance2sujg77gnqrxb,
  DurationUnit_SECONDS_getInstance as DurationUnit_SECONDS_getInstance162tnxlnf2fpv,
  convertDurationUnitOverflow as convertDurationUnitOverflow13zjt78f02ii6,
  convertDurationUnit_0 as convertDurationUnit1gi5cqpfj6qf3,
  convertDurationUnit as convertDurationUnit2jq3wf7d49p64,
};
//endregion

//# sourceMappingURL=DurationUnitJs.mjs.map
